import {$getNodeByKey} from 'lexical';

import {EnhancedTableCellNode} from './EnhancedTableCellNode';

// Registry to track table cell nodes by their ID
const tableCellNodeRegistry = new Map<string, string>(); // cellId -> nodeKey

/**
 * Register a table cell node in the registry
 */
export function registerTableCellNode(cellId: string, nodeKey: string): void {
  // Check if already registered to prevent duplicates
  if (tableCellNodeRegistry.has(cellId)) {
    const existingKey = tableCellNodeRegistry.get(cellId);
    if (existingKey === nodeKey) {
      // Same node, no need to re-register
      return;
    }
  }
  tableCellNodeRegistry.set(cellId, nodeKey);
}

/**
 * Unregister a table cell node from the registry
 */
export function unregisterTableCellNode(cellId: string): void {
  tableCellNodeRegistry.delete(cellId);
}

/**
 * Get a table cell node by its ID
 */
export function getTableCellNodeById(cellId: string): EnhancedTableCellNode | null {
  const nodeKey = tableCellNodeRegistry.get(cellId);
  if (!nodeKey) {
    return null;
  }

  const node = $getNodeByKey(nodeKey);
  return node instanceof EnhancedTableCellNode ? node : null;
}

/**
 * Get all registered table cell node IDs
 */
export function getAllTableCellNodeIds(): string[] {
  return Array.from(tableCellNodeRegistry.keys());
}
